import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface AdminPageContentProps {
    children: ReactNode;
    className?: string;
}

export function AdminPageContent({
    children,
    className,
}: AdminPageContentProps) {
    return <div className={cn(className)}>{children}</div>;
}
